import { Component, Injector } from '@angular/core';
import { AppSplashScreenService } from './core/services/splash-screen.service';
import { NavigationService } from './core/components/navigation/navigation.service';
import { AppNavigationModel } from './navigation/navigation.model';
import { Title } from '@angular/platform-browser';
import { MsAdalAngular6Service } from '@jabilcore/microsoft-adal-angular6';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  private adal: MsAdalAngular6Service;
  loginType: number = window["loginType"];

  constructor(
    private appSplashScreen: AppSplashScreenService,
    private appNavigationService: NavigationService,
    private titleService: Title,
    private injector: Injector
  ) {
    this.appNavigationService.setNavigationModel(new AppNavigationModel());

    if (this.loginType == 1) {
      this.adal = <MsAdalAngular6Service>this.injector.get(MsAdalAngular6Service);
      this.titleService.setTitle(window["configuration"].adalConfiguration.applicationName);
    }
    else
      this.titleService.setTitle(window["configuration"].applicationName);
  }
}
